import { useAuth } from "./use-auth"

export type UserType = "professional" | "individual"

export interface UserTypeInfo {
  isProfessional: boolean
  isIndividual: boolean
  userType: UserType
  hasOnboarded: boolean
}

export function useUserType(): UserTypeInfo {
  const { userAttributes } = useAuth()

  const isProfessional = userAttributes?.["custom:isProfessional"] === "true"
  const isIndividual = userAttributes?.["custom:isProfessional"] === "false"
  const userType: UserType = isProfessional ? "professional" : "individual"
  const hasOnboarded = userAttributes?.["custom:hasOnboarded"] === "true"

  return {
    isProfessional,
    isIndividual,
    userType,
    hasOnboarded,
  }
}
